export default __webpack_public_path__ + "static/media/vect221.cd9561db.png";